import React from "react"
import {
  AlertTriangleIcon,
  XOctagonIcon,
  InfoIcon,
  CheckCircle2Icon,
} from "lucide-react"
import "../styles/ToastProvider.css"

function ToastProvider({ toasts }) {
  const toastsExist = toasts && toasts.length > 0
  if (!toastsExist) return null

  const renderToasts = (toasts) => {
    return toasts.map((toast) => (
      <output className="toast" key={toast.id}>
        {toast.type === "error" && errorToast(toast.message)}
        {toast.type === "success" && successToast(toast.message)}
        {toast.type === "info" && infoToast(toast.message)}
        {toast.type === "warning" && warningToast(toast.message)}
        {toast.type === "default" && defaultToast(toast.message)}
      </output>
    ))
  }

  return <div className="toasts flex flex-col">{renderToasts(toasts)}</div>
}

export { ToastProvider }

const successToast = (message) => {
  return (
    <div className="toast alert">
      <CheckCircle2Icon className="toast-icon h-6 w-6" />
      <span>{message}</span>
    </div>
  )
}

const errorToast = (message) => {
  return (
    <div className="toast alert">
      <XOctagonIcon className="toast-icon h-6 w-6" />
      <span>{message}</span>
    </div>
  )
}

const infoToast = (message) => {
  return (
    <div className="toast alert">
      <InfoIcon className="toast-icon h-6 w-6" />
      <span>{message}</span>
    </div>
  )
}

const defaultToast = (message) => {
  return (
    <div className="toast alert">
      <span>{message}</span>
    </div>
  )
}

const warningToast = (message) => {
  return (
    <div className="toast alert">
      <AlertTriangleIcon className="toast-icon h-6 w-6" />
      <span>{message}</span>
    </div>
  )
}
